import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { FormularioRelatorioComponent } from './formulario-relatorio/formulario-relatorio.component';
import { MeusRelatoriosComponent } from './meus-relatorios/meus-relatorios.component';
import { RelatorioPrestadorComponent } from './relatorio-prestador.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: RelatorioPrestadorComponent },
      { path: 'my-reports/list', component: MeusRelatoriosComponent },
      { path: 'create', component: FormularioRelatorioComponent },
      { path: 'edit/:id', component: FormularioRelatorioComponent },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RelatorioPrestadorRoutingModule { }
